var _defs, _circle, _ellipse, _circle2, _ellipse2, _path, _circle3, _rect, _rect2, _circle4, _path2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentistAssistantTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "assistGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f89f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assistGrad2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ecb488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fccc9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assistGrad3",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f89f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f17067"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 110,
    r: 40,
    fill: "url(#assistGrad1)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 185,
    rx: 45,
    ry: 55,
    fill: "url(#assistGrad1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 125,
    r: 35,
    fill: "url(#assistGrad3)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 192,
    rx: 38,
    ry: 48,
    fill: "url(#assistGrad3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155,175 Q175,160 195,175",
    fill: "none",
    stroke: "url(#assistGrad2)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 165,
    r: 8,
    fill: "url(#assistGrad2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 230,
    width: 30,
    height: 8,
    rx: 2,
    fill: "url(#assistGrad2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 238,
    width: 6,
    height: 20,
    rx: 2,
    fill: "url(#assistGrad2)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 262,
    r: 8,
    fill: "none",
    stroke: "url(#assistGrad2)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165,275 C165,270 170,265 175,270 C180,265 185,270 185,275 C185,285 175,292 175,292 C175,292 165,285 165,275 Z",
    fill: "url(#assistGrad1)",
    opacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 300,
    width: 190,
    height: 12,
    rx: 4,
    fill: "url(#assistGrad2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentistAssistantTrack);
export default __webpack_public_path__ + "static/media/DentistAssistantTrack.80a78a0d739685057c8b587d8f46bfe7.svg";
export { ForwardRef as ReactComponent };